import * as dateUtils from './dateUtils';


export function enableStatusFilter(status) {
  return status === 0 ? '可用' : '不可用';
}

export function sexFilter(status) {
  if (status === 1) {
    return '男';
  } else if (status === 2) {
    return '女';
  }
  return '-';
}

export function stateFilter(endTime, joinEndTime, beginTime) {
  const nowTime = (new Date()).getTime();
  if (nowTime < joinEndTime) return "报名中"
  if (nowTime > joinEndTime && nowTime < beginTime) return "即将开始"
  if (nowTime > beginTime && nowTime < endTime) return "进行中"
  if (nowTime > endTime) return "已结束"

  console.log("joinEndTime", nowTime)
}

export function priceFilter(price) {
  const priceNumber = parseFloat(price);
  if (isNaN(priceNumber)) return '';
  return priceNumber.toFixed(2);
}

export function undefineFilter(str) {
  return str !== '' ? str : '-';
}

/* eslint no-bitwise:["error", { "allow": ["~"] }] */
export function ageFilter(dateString) {
  const birthday = +new Date(dateString);
  return ~~((Date.now() - birthday) / (31557600000));
}

export function jsTimestampFilter(timestamp, parttern = 'yyyy-MM-dd') {
  if (!timestamp) {
    return '';
  }
  if (typeof timestamp === 'object') {
    return timestamp.format('yyyy-MM-dd');
  }
  const formatedtimestamp = parseInt(timestamp, 10);
  if (isNaN(formatedtimestamp)) return '';

  const day = new Date(formatedtimestamp);
  return dateUtils.format(day, parttern);
}

export function unixTimestampFilter(timestamp, parttern) {
  const formatedtimestamp = parseInt(timestamp, 10);

  if (isNaN(formatedtimestamp)) return '';
  return jsTimestampFilter(formatedtimestamp * 1000, parttern);
}

// 末尾补0
export function paddingEndZero(value, len) {
  let newValue = value + '';
  if (newValue.indexOf('.') === -1) {
    newValue += '.';
  }
  for (let i = 0; i < len; i++) {
    newValue += '0';
  }
  const index = newValue.indexOf('.');
  return newValue.substr(0, index + len + 1);
}

export function orderStatusFilter(status, type) {
  switch (status){
    case 1:
      return type==9 ? '待接单' : '待审批';
    case 2:
      return '审批中';
    case 3:
      return '审批不通过';
    case 4:
      return '用户取消';
    case 5:
      return '待支付';
    case 6:
      return '完成';
    case 7:
      return '订单关闭';
    case 8:
      return '已退款';
    case 9:
      return '退款中';
    case 0:
      return '删除';
    default:
      return '——';
  }
}

export function payTypeFilter(payType) {
  switch (payType){
    case 1:
      return '微信支付';
    case 2:
      return '月结';
    default:
      return '——';
  }
}

export function scoreFilter(score) {
  switch (score){
    case 1:
      return '非常不满意';
    case 2:
      return '不满意';
    case 3:
      return '一般';
    case 4:
      return '比较满意';
    case 5:
      return '非常满意';
    default:
      return '未评价';
  }
}

export function salaryFilter(salary) {
  if (salary === 1) {
    return '面议 ';
  } else if (salary === 2) {
    return '低于2K';
  } else if (salary === 3) {
    return '2-3K';
  } else if (salary === 4) {
    return '3-4.5K';
  } else if (salary === 5) {
    return '4.5-6K';
  } else if (salary === 6) {
    return '6-8K';
  } else if (salary === 7) {
    return '8-10K';
  } else if (salary === 8) {
    return '10-15K';
  } else if (salary === 9) {
    return '15-20K';
  } else if (salary === 10) {
    return '20-30K';
  } else if (salary === 11) {
    return '30-40K';
  } else if (salary === 12) {
    return '40-50K';
  } else if (salary === 13) {
    return '50K以上';
  } else {
    return '';
  }
}

export function educationFilter(education) {
  if (education === 1) {
    return '初中及以下';
  } else if (education === 2) {
    return '高中/中技/中专';
  } else if (education === 3) {
    return '大专';
  } else if (education === 4) {
    return '本科';
  } else if (education === 5) {
    return '硕士';
  } else if (education === 6) {
    return '博士';
  } else {
    return '';
  }
}

export function jobExperiencesFilter(year) {
  if (year === 1) {
    return '有无经验均可';
  } else if (year === 2) {
    return '1-3年';
  } else if (year === 3) {
    return '3-5年';
  } else if (year === 4) {
    return '5-10年';
  } else if (year === 5) {
    return '10年以上';
  } else {
    return '';
  }
}

export function jobTypeFilter(jobType) {
  return jobType === 0 ? '全职' : '兼职';
}

export default {};



// WEBPACK FOOTER //
// ./src/utils/filters.js